import { DecimalPipe } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Language } from 'app/model/constant';
import { DestinationTravelPolicy } from 'app/model/products/hotel/hotel.model';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import * as moment from 'vendors/moment-locale-th';
import { BUDGET_TYPE, Item, TOTAL_BUDGET_TYPE } from '../../budget-limit.model';

@Component({
  selector: 'act-dialog-budget-limit-detail',
  templateUrl: './dialog-budget-limit-detail.component.html',
  styleUrls: ['./dialog-budget-limit-detail.component.scss']
})
export class DialogBudgetLimitDetailComponent implements OnInit {

  public name = 'dialog-budget-limit-detail';
  public lang;
  public titleList = [];
  public dayList = [];
  public itemList = [];
  public totalList = [];
  public tableList = [];
  public shareBudgetDestination = [];
  public averageBudget: string;
  public isMobile: boolean = false
  public isPOIs: boolean;

  constructor(
    private dialogRef: MdDialogRef<DialogBudgetLimitDetailComponent>,
    private appConfigService: AppConfigService,
    private translate: TranslatePipe,
    private decimal: DecimalPipe,
    private utilities: UtilitiesService,
    @Inject(MD_DIALOG_DATA) private data: {
      budgetBooker?: number,
      budgetCoBooker?: number,
      coBudget?: number,
      coBudgetUnlimited?: boolean,
      appliedCoBudget?: boolean,
      destinationTravelPolicyBooker?: DestinationTravelPolicy[];
      destinationTravelPolicyCoBooker?: DestinationTravelPolicy[];
      isShareBudget: boolean;
    }
  ) {
    moment.locale(this.lang);
    this.lang = this.appConfigService.getLanguage();
    this.isMobile = this.utilities.isMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--height-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.onResize();
    if (this.data.isShareBudget) {
      this.transformShareBudget();
    } else {
      if (this.isMobile && this.data.destinationTravelPolicyBooker.length > 1) {
        this.transformMobileCasePOIs();
      } else {
        this.transformTravelPolicyDestination();
      }
    }
  }

  transformTravelPolicyDestination() {
    this.averageBudget = this.data && this.data.destinationTravelPolicyBooker.length > 0 && this.transformBudget(this.data.destinationTravelPolicyBooker[0].averageBudget);
    const roundDestination = this.data.destinationTravelPolicyBooker.length;
    const destinationPolicyNotEmptyTravelPolicy = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(this.data.destinationTravelPolicyBooker);
    const roundDays = destinationPolicyNotEmptyTravelPolicy.travelPolicyList.length;

    for (let index = 0; index < roundDestination; index++) {
      if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
        this.titleList.push(this.lang === Language.en ? `${this.translate.transform('budget-limit-for')} ${this.data.destinationTravelPolicyBooker[index].destinationNameEn}` : `${this.translate.transform('budget-limit-for')}${this.data.destinationTravelPolicyBooker[index].destinationNameTh}`);
        this.totalList.push(this.data.destinationTravelPolicyBooker[index].averageBudget ? this.transformBudget(this.data.destinationTravelPolicyBooker[index].averageBudget, true) : `${this.translate.transform('budget-limit-unlimited')}`);
      }
    }

    for (let day = 0; day < roundDays; day++) {
      this.dayList = [];
      this.dayList.push(new Item(this.transformDateString(destinationPolicyNotEmptyTravelPolicy, day)));

      for (let index = 0; index < roundDestination; index++) {
        if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
          const item = this.data.destinationTravelPolicyBooker[index].travelPolicyList ? this.data.destinationTravelPolicyBooker[index].travelPolicyList[day] : undefined;
          const budget = item ? (item.budget ? this.transformBudget(item.budget) : `${this.translate.transform('budget-limit-unlimited')}`) : (this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : `${this.translate.transform('budget-limit-unlimited')}`);
          if (item.budgetType === BUDGET_TYPE.NEW_BUDGET) {
            this.dayList.push(new Item(budget, `${this.translate.transform('budget-limit-budget-special')}`));
          } else {
            this.dayList.push(new Item(budget));
          }
        }
      }
      this.itemList.push(this.dayList);
    }
    this.isPOIs = this.titleList.length > 1;
  }

  transformMobileCasePOIs() {
    const roundDestination = this.data.destinationTravelPolicyBooker.length;
    const destinationPolicyNotEmptyTravelPolicy = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(this.data.destinationTravelPolicyBooker);
    const roundDays = destinationPolicyNotEmptyTravelPolicy.travelPolicyList.length;

    for (let index = 0; index < roundDestination; index++) {
      if (this.data.destinationTravelPolicyBooker[index].travelPolicyList) {
        this.titleList.push(this.lang === Language.en ? `${this.translate.transform('budget-limit-for')} ${this.data.destinationTravelPolicyBooker[index].destinationNameEn}` : `${this.translate.transform('budget-limit-for')}${this.data.destinationTravelPolicyBooker[index].destinationNameTh}`);
        this.totalList.push(this.data.destinationTravelPolicyBooker[index].averageBudget ? this.transformBudget(this.data.destinationTravelPolicyBooker[index].averageBudget) : `${this.translate.transform('budget-limit-unlimited')}`);
        this.itemList = [];

        for (let day = 0; day < roundDays; day++) {
          this.dayList = [];
          this.dayList.push(new Item(this.transformDateString(destinationPolicyNotEmptyTravelPolicy, day)));

          const item = this.data.destinationTravelPolicyBooker[index].travelPolicyList ? this.data.destinationTravelPolicyBooker[index].travelPolicyList[day] : undefined;;
          const budget = item ? (item.budget ? this.transformBudget(item.budget) : `${this.translate.transform('budget-limit-unlimited')}`) : (this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : `${this.translate.transform('budget-limit-unlimited')}`);
          if (item.budgetType === BUDGET_TYPE.NEW_BUDGET) {
            this.dayList.push(new Item(budget, `${this.translate.transform('budget-limit-budget-special')}`));
          } else {
            this.dayList.push(new Item(budget));
          }
          this.itemList.push(this.dayList);
        }
        this.tableList.push(this.itemList);
      }
    }
    this.isPOIs = this.titleList.length > 1;
  }

  transformShareBudget() {
    this.shareBudgetDestination = this.findShareBudgetDestination(this.data.destinationTravelPolicyBooker, this.data.destinationTravelPolicyCoBooker);
    this.isPOIs = this.shareBudgetDestination.length > 1;

    const isDestinationTravelPolicy = this.isDestinationTravelPolicy(this.data.destinationTravelPolicyBooker);
    const isDestinationTravelPolicyCoBooker = this.isDestinationTravelPolicy(this.data.destinationTravelPolicyCoBooker);

    const booker = isDestinationTravelPolicy ? {
      budget: this.data.destinationTravelPolicyBooker[0].totalBudget,
      destination: this.data.destinationTravelPolicyBooker.length,
      days: Math.max(...this.data.destinationTravelPolicyBooker.map(d => d.travelPolicyList ? d.travelPolicyList.length : 0))
    } : { budget: this.data.budgetBooker, destination: 0, days: 0 }
    const coBooker = isDestinationTravelPolicyCoBooker ? {
      budget: this.data.destinationTravelPolicyCoBooker[0].totalBudget,
      destination: this.data.destinationTravelPolicyCoBooker.length,
      days: Math.max(...this.data.destinationTravelPolicyCoBooker.map(d => d.travelPolicyList ? d.travelPolicyList.length : 0))
    } : { budget: this.data.budgetCoBooker, destination: 0, days: 0 }
    const roundDays = Math.max(booker.days, coBooker.days);
    this.averageBudget = this.transformBudget(booker.budget + coBooker.budget);
    for (let index = 0; index < this.shareBudgetDestination.length; index++) {
      const destinationId = this.shareBudgetDestination[index].id;

      const indexDestinationBooker = this.findIndexListDestinationTravelPolicy(this.data.destinationTravelPolicyBooker, destinationId);

      const appliedCoBudget = this.data.destinationTravelPolicyBooker[indexDestinationBooker].appliedCoBudget;
      const totalBudget = this.data.destinationTravelPolicyBooker[indexDestinationBooker].totalBudget

      this.totalList.push({
        totalBudget: totalBudget ? this.transformBudget(totalBudget, true) : `${this.translate.transform('budget-limit-unlimited')}`,
        appliedCoBudget: appliedCoBudget
      });
      this.itemList = [];

      const listDay = isDestinationTravelPolicy ? this.data.destinationTravelPolicyBooker : this.data.destinationTravelPolicyCoBooker;
      const destinationPolicyNotEmptyTravelPolicyList = this.findDestinationTravelPolicyNotEmptyTravelPolicyList(listDay);
      for (let day = 0; day < roundDays; day++) {
        this.dayList = [];
        this.dayList.push(new Item(this.transformDateString(destinationPolicyNotEmptyTravelPolicyList, day)));

        const resultBooker = this.prepareDataShareBudget(this.data.destinationTravelPolicyBooker, this.data.budgetBooker, destinationId, day, true);
        this.dayList.push.apply(this.dayList, resultBooker.dayList);

        const resultCoBooker = this.prepareDataShareBudget(this.data.destinationTravelPolicyCoBooker, this.data.budgetCoBooker, destinationId, day, false);
        this.dayList.push.apply(this.dayList, resultCoBooker.dayList);

        const totalBudget = resultBooker.appliedCoBudget ?
          resultBooker.totalBudget ?  this.transformBudget(resultBooker.totalBudget) : `${this.translate.transform('budget-limit-unlimited')}`:
          resultBooker.dailyBudget + resultCoBooker.dailyBudget ? this.transformBudget(resultBooker.dailyBudget + resultCoBooker.dailyBudget) : `${this.translate.transform('budget-limit-unlimited')}`

        this.dayList.push({
          totalBudget: totalBudget,
          appliedCoBudget: resultBooker.appliedCoBudget
        });
        this.itemList.push(this.dayList);
      }
      this.tableList.push(this.itemList);
    }
  }

  findShareBudgetDestination(travelpolicyListBooker: DestinationTravelPolicy[], travelpolicyListCoBooker: DestinationTravelPolicy[]) {
    let destinations = [];
    travelpolicyListBooker && travelpolicyListBooker.forEach(f => {
      if (f.appliedCoBudget || f.travelPolicyList) {
        destinations.push({ id: f.destinationId, name: this.lang === Language.th ? f.destinationNameTh : f.destinationNameEn });
      }
    });

    travelpolicyListCoBooker && travelpolicyListCoBooker.forEach(f => {
      if (f.appliedCoBudget || f.travelPolicyList) {
        destinations.push({ id: f.destinationId, name: this.lang === Language.th ? f.destinationNameTh : f.destinationNameEn });
      }
    });
    destinations = destinations.filter(obj => !destinations[obj.id] && (destinations[obj.id] = true));
    return destinations;
  }

  prepareDataShareBudget(travelpolicyList: DestinationTravelPolicy[], normalBudget: number, destinationId: number, day: number, isMainBooker: boolean) {
    let budget: number;
    let dayList = [];
    const indexDestination = this.findIndexListDestinationTravelPolicy(travelpolicyList, destinationId);

    if (indexDestination !== -1) {
      if (travelpolicyList[indexDestination].travelPolicyList) {
        const item = travelpolicyList[indexDestination].travelPolicyList[day];
        const budgeBooker = item.budget ? this.transformBudget(item.budget) : `${this.translate.transform('budget-limit-unlimited')}`;
        budget = +item.budget;
        if (item.budgetType === BUDGET_TYPE.NEW_BUDGET) {
          dayList.push(new Item(budgeBooker, `${this.translate.transform('budget-limit-budget-special')}`));
        } else {
          dayList.push(new Item(budgeBooker));
        }
      } else {
        if (isMainBooker) {
          dayList.push(new Item(this.data.budgetBooker ? this.transformBudget(this.data.budgetBooker) : `${this.translate.transform('budget-limit-unlimited')}`));
        } else {
          dayList.push(new Item(this.data.budgetCoBooker ? this.transformBudget(this.data.budgetCoBooker) : `${this.translate.transform('budget-limit-unlimited')}`));
        }
      }
    } else {
      dayList.push(new Item(normalBudget ? this.transformBudget(normalBudget) : `${this.translate.transform('budget-limit-unlimited')}`));
      budget = normalBudget;
    }

    let appliedCoBudget;
    let dailyBudget;
    let totalBudget;

    if (travelpolicyList[indexDestination] && travelpolicyList[indexDestination].travelPolicyList) {
      appliedCoBudget = travelpolicyList[indexDestination].travelPolicyList[day].totalBudgetType === TOTAL_BUDGET_TYPE.CO_BUDGET ||
      travelpolicyList[indexDestination].travelPolicyList[day].totalBudgetType === TOTAL_BUDGET_TYPE.SPECIAL_CO_BUDGET
      dailyBudget = travelpolicyList[indexDestination].travelPolicyList[day].budget;
      totalBudget = travelpolicyList[indexDestination].travelPolicyList[day].totalBudget;
    } else {
      appliedCoBudget = travelpolicyList[indexDestination].appliedCoBudget;
      dailyBudget = normalBudget;
      totalBudget = appliedCoBudget ? this.data.coBudget : undefined;
    }
    return { budget, dayList, dailyBudget, totalBudget, appliedCoBudget };
  }

  transformDateString(destinationTravelPolicy: DestinationTravelPolicy, day) {
    let dateString = '';
    dateString = moment(destinationTravelPolicy.travelPolicyList[day].date, this.appConfigService.dateAPIFormat).locale(this.lang).format(this.appConfigService.dateTravelPolicyFormat);
    dateString = this.lang === Language.th ? this.utilities.convertYearToBuddhist(dateString) : dateString;
    return dateString;
  }

  onClose() {
    this.dialogRef.close();
  }

  onGoTable(index: number) {
    setTimeout(() => {
      try {
        document.getElementById(`${this.name}-table-${index}`).scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (error) { }
    }, 400);
  }

  transformBudget(budget, highlight = false) {
    if (highlight) {
      return `THB <b>${this.decimal.transform(budget, '1.0')}</b>`;
    }
    return `THB ${this.decimal.transform(budget, '1.0')}`;
  }

  findIndexListDestinationTravelPolicy(travelpolicyList: DestinationTravelPolicy[], destinationId: number) {
    if (travelpolicyList) {
      return travelpolicyList.findIndex(f => f.destinationId == destinationId);
    } else {
      return -1;
    }
  }

  findDestinationTravelPolicyNotEmptyTravelPolicyList(destinationTravelPolicyList: DestinationTravelPolicy[]) {
    return destinationTravelPolicyList.find(d => d.travelPolicyList && d.travelPolicyList.length > 0);
  }

  isDestinationTravelPolicy(destinationTravelPolicyList: DestinationTravelPolicy[]) {
    if (destinationTravelPolicyList && destinationTravelPolicyList.length > 0) {
      for (const destination of destinationTravelPolicyList) {
        if (destination.travelPolicyList && destination.travelPolicyList.length > 0) {
          return true;
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/budget-limit/dialog-budget-limit/dialog-budget-limit-detail/dialog-budget-limit-detail.component.ts